// src/Footer.tsx
import React from "react";

export default function Footer() {
  return (
    <footer 
      className="text-white py-8 md:py-14"
      style={{
        background: "linear-gradient(135deg, #000000 0%, #1a1a1a 20%, #2d2d2d 40%, #1a1a1a 60%, #0d0d0d 80%, #000000 100%)",
        borderTop: "1px solid rgba(255, 255, 255, 0.1)"
      }}
    >
      <div className="max-w-full flex flex-col md:flex-row justify-between items-start gap-8 px-4 md:px-8">
        {/* Partie gauche */}
        <div className="w-full md:w-auto">
          <h1 className="text-4xl md:text-6xl font-serif mb-3 md:mb-5" style={{ fontFamily: "Baskerville, serif" }}>
            LX Proto3D
          </h1>
          <p className="text-sm md:text-base font-sans mb-4" style={{ fontFamily: "Almarai, sans-serif" }}>
            Conception et Impression 3D pour professionnels et <br className="hidden md:block"/> particuliers – vos idées, notre savoir-faire.
          </p>  
        </div>

        {/* Partie droite */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 w-full md:w-auto">
          {/* Contact */}
          <div className="text-left">
            <h2 className="text-2xl md:text-3xl font-serif mb-2 md:mb-3" style={{ fontFamily: "Baskerville, serif" }}>
              Contact
            </h2>
            <p className="text-sm md:text-base font-sans mb-4" style={{ fontFamily: "Almarai, sans-serif" }}>
              contact@lxproto3d.fr <br />
              +33 6 48 20 00 44
            </p>
          </div>

          {/* Localisation */}
          <div className="text-left">
            <h2 className="text-2xl md:text-3xl font-serif mb-2 md:mb-3" style={{ fontFamily: "Baskerville, serif" }}>
              Localisation
            </h2>
            <p className="text-sm md:text-base font-sans" style={{ fontFamily: "Almarai, sans-serif" }}>
              Oloron-Sainte-Marie, 64400 <br />
              France
            </p>
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="text-center mt-6 md:mt-4 font-almarai text-sm md:text-base px-4">
        © 2025 LX Proto3D – Conception et Impression 3D
      </div>
      <div className="text-center mt-2 font-almarai text-xs md:text-sm px-4" style={{ color: "#b0b0b0" }}>
        Tous les contenus, images et objets 3D sont la propriété de LX Proto3D et ne peuvent être réutilisés sans autorisation.
      </div>
    </footer>
  );
}